import { useSuspenseQuery } from '@tanstack/react-query';
import { airportsIdMetarGet } from '@/api/core/airports/airportsIdMetarGet';

export const useAirportMetar = (id: number) => useSuspenseQuery({
    queryKey: ['airportMetar', id],
    queryFn: () => airportsIdMetarGet(id).then(r => r.payload)
});
